import type { Customer } from '../../../types/domain';
import { isDocumentRequired } from '../../../utils/profileValidation';
import { formatDocument, phoneDigits, validateDocument } from '../../../utils/validators';

export type ProfileFormFields = Customer;

export function validateProfileForm(
  data: ProfileFormFields,
): Partial<Record<keyof ProfileFormFields, string>> {
  const errors: Partial<Record<keyof ProfileFormFields, string>> = {};
  const requireDocument = isDocumentRequired();

  if (!data.firstName.trim()) errors.firstName = 'Nome é obrigatório';
  if (!data.lastName.trim()) errors.lastName = 'Sobrenome é obrigatório';

  if (requireDocument && !data.documentNumber.trim()) {
    errors.documentNumber = 'CPF é obrigatório';
  } else if (data.documentNumber.trim() && !validateDocument(data.documentNumber, 'CPF')) {
    errors.documentNumber = 'CPF inválido';
  }

  const digits = phoneDigits(data.phone ?? '');
  if (!data.phone?.trim()) {
    errors.phone = 'Telefone é obrigatório';
  } else if (digits.length < 10) {
    errors.phone = 'Telefone deve ter pelo menos 10 dígitos';
  } else if (digits.length > 11) {
    errors.phone = 'Telefone deve ter no máximo 11 dígitos';
  }

  return errors;
}

export function emptyProfileForm(): ProfileFormFields {
  return {
    firstName: '',
    lastName: '',
    documentNumber: '',
    phone: '',
  };
}

export function profileFormFromMe(data: {
  firstName?: string;
  lastName?: string;
  documentNumber?: string;
  phone?: string;
}): ProfileFormFields {
  return {
    firstName: data.firstName ?? '',
    lastName: data.lastName ?? '',
    documentNumber: data.documentNumber ? formatDocument(data.documentNumber, 'CPF') : '',
    phone: data.phone ?? '',
  };
}
